import { useMutation, useQueryClient } from '@tanstack/react-query'
import NamedValuesService from '../../../services/NamedValues.service'

type UpdateNamedValuePayload = {
  organization: string
  name: string
  value: string
}

export const useUpdateVariableValue = () => {
  const queryClient = useQueryClient()

  return useMutation<any, Error, UpdateNamedValuePayload>({
    mutationKey: ['named-value-update-value'],
    mutationFn: (payload) => NamedValuesService.updateValue(payload.organization, payload.name, payload.value),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['named-values'] })
    },
  })
}
